var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
export var textMessage = function textMessage(siteApi, centralApi, getToken) {
  return {
    index: function index(params) {
      if (params === void 0) {
        params = {};
      }
      return siteApi.get('/text-message', {
        params: params
      });
    },
    excelIndexUrl: function excelIndexUrl(params) {
      return siteApi.buildUrl('/text-message.xls', __assign(__assign({}, params), {
        token: getToken().accessToken
      }));
    },
    pdfUrl: function pdfUrl(params) {
      if (params === void 0) {
        params = {};
      }
      return siteApi.buildUrl('/text-message.pdf', __assign(__assign({}, params), {
        token: getToken().accessToken
      }));
    },
    asset: {
      delete: function _delete(id, data) {
        return centralApi.delete("/text-message/".concat(id, "/asset"), {
          params: data
        });
      }
    }
  };
};